import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import {
  BASE_PERMISSIONS,
  baseAdministrationActions,
  baseAdministrationSelectors,
  BaseAdministrationService,
  BaseButtonSize,
  BaseCommonFormComponent,
  BaseCoreState,
  BaseHelpersService,
  BaseRolesService,
  BaseSharedFormBuilderService,
  companyMainFormKey,
  createCompanyMainFormGroup,
  CustomerMainFormInterface,
  CustomerResponse,
} from 'base';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'base-customer-administration-master-data',
  templateUrl: './base-customer-master-data.component.html',
})
export class BaseCustomerAdministrationMasterDataComponent
  extends BaseCommonFormComponent
  implements OnInit, OnDestroy
{
  buttonSizes = BaseButtonSize;
  submitted = false;
  isEditMode = false;
  modalRef: NgbModalRef;
  mainForm: FormGroup<CustomerMainFormInterface>;
  hasMasterDataAccess: boolean;
  destroy$ = new Subject();

  constructor(
    private readonly sharedFormBuilderService: BaseSharedFormBuilderService,
    private administrationService: BaseAdministrationService,
    private rolesService: BaseRolesService,
    protected store: Store<BaseCoreState>
  ) {
    super(store);

    this.mainForm = this.sharedFormBuilderService.sharedGroup(companyMainFormKey, createCompanyMainFormGroup);
    this.mainForm.updateValueAndValidity();
  }

  ngOnInit(): void {
    this.hasMasterDataAccess = this.rolesService.hasCustomerFeaturePermission(
      BASE_PERMISSIONS.FEATURE_ADMIN_MASTER_DATA
    );

    this.store
      .select(baseAdministrationSelectors.getCustomerDataData)
      .pipe(
        map((data) => data as CustomerResponse),
        takeUntil(this.destroy$)
      )
      .subscribe((result: CustomerResponse) => {
        this.mainForm.controls.contact.patchValue({
          ...result.contact,
          ...result.primaryData,
          vatId: result.vatId,
        });
        this.mainForm.controls.businessAddress.patchValue(result.businessAddress as any);
        this.mainForm.controls.billingAddress.patchValue(result.billingAddress as any);

        this.initState = BaseHelpersService.convertObjToTuple(result);
      });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.destroy$.next(true);
  }

  fillBillingAddress(): void {
    this.mainForm.controls.billingAddress.patchValue(this.mainForm.controls.businessAddress.value);
  }

  saveChanges(): void {
    this.submitted = true;
    this.mainForm.markAllAsTouched();
    if (this.mainForm.valid) {
      const preparedData = this.administrationService.prepareCustomerUpdateModel(this.mainForm.value);
      this.store.dispatch(baseAdministrationActions.updateCustomerInfo({ payload: preparedData }));
      this.isEditMode = false;
    }
  }
}
